<agc-form [formGroup]="form" (submit)="submit()">
  <div class="row m-b-20">
    <div class="col-md-12">
      <h3 class="text-center">User Registration</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <agc-form-field>
        <label for="">First Name <span class="text-danger">*</span></label>
        <input type="text" formControlName="firstName" class="form-control" required>
        <agc-message when="required">First Name is required.</agc-message>
      </agc-form-field>
    </div>

    <div class="col-md-6">
      <agc-form-field>
        <label for="">Last Name <span class="text-danger">*</span></label>
        <input type="text" formControlName="lastName" class="form-control" required>
        <agc-message when="required">Last Name is required.</agc-message>
      </agc-form-field>
    </div>
  </div>

  <agc-form-field>
    <label for="">Email Address <span class="text-danger">*</span></label>
    <input type="text" formControlName="email" class="form-control" email autocomplete="email" emailAvailable required>
    <agc-message when="required">Email address is required.</agc-message>
    <agc-message when="email">Email does not appear to be valid.</agc-message>
    <agc-message when="emailAvailable">An account with this email already exists.</agc-message>
  </agc-form-field>

  <agc-form-field>
    <label for="">Username <span class="text-danger">*</span></label>
    <input type="text" formControlName="username" class="form-control" autocomplete="username" required username usernameAvailable>
    <agc-message when="required">Username is required.</agc-message>
    <agc-message when="username">Username does not appear to be valid.</agc-message>
    <agc-message when="usernameAvailable">An account with this username already exists.</agc-message>
  </agc-form-field>

  <agc-form-field>
    <label for="">Password <span class="text-danger">*</span></label>
    <input type="password" formControlName="password" class="form-control" autocomplete="new-password" required>
    <agc-message when="required">Password is required.</agc-message>
  </agc-form-field>

  <agc-form-field>
    <label for="">Confirm Password <span class="text-danger">*</span></label>
    <input type="password" formControlName="confirmPassword" class="form-control" autocomplete="new-password" required equals="password">
    <agc-message when="required">Please confirm your password.</agc-message>
    <agc-message when="equals">Passwords do not match.</agc-message>
  </agc-form-field>

  <agc-form-field>
    <label for="">Are you human? <span class="text-danger">*</span></label>
    <agc-recaptcha formControlName="recaptcha" required></agc-recaptcha>
    <agc-message when="required">Please verify that you're human.</agc-message>
  </agc-form-field>

  <div class="row m-t-30">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary btn-md btn-block waves-effect waves-light text-center m-b-20">Register</button>
    </div>
  </div>

  <hr>

  <p class="text-inverse text-center m-b-0">
    Already have an account? <a [routerLink]="['/']"><b class="f-w-600">Sign In</b></a>
  </p>
</agc-form>
